import { useEffect, useState } from "react";
import { getAssessmentInterpolation } from "utils/api";
import { showNotification } from "utils/notifications";

export function useAssessmentInterpolation(
  assessmentId: string,
  measureId: string | null,
  measureValue: string | null,
  error: boolean,
  onUpdate: (interpolations: Record<string, number> | null) => void
): boolean {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // Note measureValue is a string so we dont need to worry about 0 atm
    if (assessmentId && measureId && measureValue && !error) {
      setLoading(true);
      const signal = new AbortController().signal;
      getAssessmentInterpolation(assessmentId, measureId, measureValue, signal)
        .then(onUpdate)
        .catch((err) => {
          onUpdate(null);
          if (err.name === "AbortError") {
            console.log("Fetch aborted: previous request cancelled or component unmounted");
          } else {
            showNotification({
              message: `Failed to get interpolated values. Please refresh your browser and try again.`,
              severity: "error",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [assessmentId, measureId, measureValue, error, onUpdate]);

  return loading;
}
